import { actionTypes } from '../../../types';

export const optCampaignNotPublished = (payload, callback) => ({
    type: actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_REQUEST,
    payload,
    callback
});

export const optCampaignNotPublishedSuccess = (payload) => ({
    type: actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_SUCCESS,
    payload,
});

export const optCampaignNotPublishedFailure = (payload) => ({
    type: actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_FAILURE,
    payload,
});

export const optCampaignNotPublishedReset = () => ({
    type: actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_RESET,
});

export const optCampaignNotPublishedResetAll = () => ({
    type: actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_RESET_ALL,
});
